<app-modal [dismissible]="false" (show)="modalOnOpened()">
    <div class="modal-header" modal-header>
        <ng-content select="app-wizard-title"></ng-content>
        <span *ngIf="steps"> </span>
        <ng-container *ngFor="let step of steps; let index = index;">
            <div *ngIf="vertical && index === activeStepIndex"
                 class="step-title">
                <ng-container *ngTemplateOutlet="step.title"></ng-container>
            </div>
        </ng-container>
    </div>
    <div class="modal-body" modal-body>
        <div class="steps" *ngIf="!hideSteps">
            <li *ngFor="let step of steps; let index = index;"
                [class.active]="isStepActive(index)"
                [class.complete]="isStepComplete(index)">
                <div class="step-card">
                    <div class="step-counter">
                        <i *ngIf="isStepComplete(index)"
                           class="material-icons">check</i>
                        <span *ngIf="!isStepComplete(index)">{{ index + 1 }}</span>
                    </div>
                    <div class="step-label">
                        <ng-container *ngTemplateOutlet="step.title"></ng-container>
                    </div>
                </div>
            </li>
        </div>
        <div class="separator" *ngIf="!hideSteps"></div>
        <div class="content"
             *ngIf="activeStep;">
            <div [ngClass]="{'overlay': activeStep.showOverlay}"></div>
            <ng-container *ngFor="let step of steps; let index = index;">
                <div class="actual-step" [hidden]="(index !== activeStepIndex) || isLoading">
                    <ng-container *ngTemplateOutlet="step.content; context: {step: step}"></ng-container>
                </div>
            </ng-container>
            <app-loading-spinner *ngIf="isLoading" class="loader"></app-loading-spinner>
        </div>
    </div>
    <div class="modal-footer" modal-footer>
        <div class="actions"
             [class.after-submit]="isStepAfterSubmit"
             *ngIf="activeStep">
            <app-button type="simple"
                        *ngIf="isFirstStep"
                        [disabled]="isLoading"
                        (click)="onCancelClick()">
                {{ 'generic.buttons.close'| translate }}
            </app-button>
            <app-button type="simple"
                        *ngIf="!isFirstStep && !isStepAfterSubmit"
                        [disabled]="isLoading"
                        (click)="prev()">
                <i class="material-icons">chevron_left</i> {{ 'generic.buttons.back'| translate }}
            </app-button>
            <div class="mutators">
                <app-button *ngIf="!isLastStep && !canStepSave"
                            [disabled]="nextDisabled"
                            type="primary"
                            (clicked)="next()">
                    {{ 'generic.buttons.next'| translate }}
                    <i class="material-icons">chevron_right</i>
                </app-button>
                <div data-toggle="tooltip" [title]="canDeleteTooltipText">
                    <app-button *ngIf="!isReadOnlyMode && hasDelete && isEditMode && (isLastStep || canStepSave) && !isStepAfterSubmit"
                                [disabled]="!canDelete || isLoading"
                                type="danger"
                                (click)="onDelete()">
                        {{ 'generic.buttons.delete'| translate }}
                    </app-button>
                </div>
                <app-button *ngIf="!isReadOnlyMode && !concludesInDelete && (isLastStep || canStepSave) && !isStepAfterSubmit"
                            [disabled]='isLoading || isSaveDisabled'
                            type="primary"
                            (click)="finalSubmit()">
                    {{ (isViewMode ? 'generic.buttons.finish' : 'generic.buttons.save') | translate }}
                </app-button>
                <app-button *ngIf="!isReadOnlyMode && concludesInDelete && (isLastStep || canStepSave) && !isStepAfterSubmit"
                            type="danger"
                            [disabled]="isLoading"
                            (click)="finalSubmit()">
                    {{ 'generic.buttons.delete'| translate }}
                </app-button>
                <app-button *ngIf="!isReadOnlyMode && canSkipStep"
                            type="warning"
                            [disabled]="isLoading"
                            (click)="skipStep()">
                    {{ 'generic.buttons.finish'| translate }}
                </app-button>
                <app-button *ngIf="!isReadOnlyMode && isStepAfterSubmit"
                            type="warning"
                            [disabled]="isLoading"
                            (click)="onCancelClick()">
                    {{ 'generic.buttons.finish'| translate }}
                </app-button>
            </div>
        </div>
    </div>
</app-modal>

<ng-template #loadingAnimation>

</ng-template>
